import initSharedPromotion from '@resources/js/components/promotion/initSharedPromotion'
import inViewport from '@resources/js/helpers/inViewport'
import MapView from '@resources/js/maps/MapView'
import MapHotelsStore from '@resources/js/maps/MapStores/MapHotelsStore'
import '@resources/js/analytics'

initSharedPromotion()

// map
inViewport("#mapbox", () => {
    const map = new MapView({ zoom: 12 })
    const mapHotelsStore = new MapHotelsStore()
    const data = mapHotelsStore.getData()
    map.addMarkers(data)
    map.fitByCoords(mapHotelsStore.getCoordinates())
})
